// let modalContainer = document.querySelector('.overlay-content');
// let modals = document.querySelectorAll('.overlay-content .overlay');
//
// const modalTriggers = document.querySelectorAll('.hero-nav > button');
// let closeModalButton = document.querySelector('.overlay-content .close-button');
//
// let openOverlay = "";
//
// let modal
//
// modalTriggers.forEach(trigger => {
//     trigger.addEventListener('click', function handleClick(event) {
//         openOverlay = trigger.getAttribute('data-modal');
//         console.log(openOverlay);
//         openModal(openOverlay);
//     });
// });
//
// closeModalButton.addEventListener('click', (event) => {
//     closeModal();
// });
//
// function openModal(overlay) {
//     modals.forEach(modal => {
//         let elOverlay = modal.getAttribute('data-modal');
//         if (overlay != elOverlay) {
//             modal.classList.remove('visible');
//         } else {
//             modal.classList.add('visible');
//         }
//     });
//
//     // Open the modal container
//     modalContainer.classList.add('visible');
// }
//
// function closeModal() {
//     modalContainer.classList.remove('visible');
// }

import {toggleNav} from "./navigation";

const modalOverlay = document.querySelector(".modal-overlay");
const modal = document.querySelector(".modal");
const viewFilmButtons = document.querySelectorAll(".view-film")
const viewBrochureButtons = document.querySelectorAll(".view-brochure");
const filmDiv = document.querySelector(".modal .film");
const film = document.querySelector(".modal .film iframe");
const brochureDiv = document.querySelector(".modal .brochure");
const modalCloseBtn = document.querySelector('.modal .close-btn');
const nav = document.querySelector("nav");
const main = document.querySelector("main");


viewFilmButtons.forEach(button => {
  button.addEventListener('click', openModal);
});

viewBrochureButtons.forEach(button => {
  button.addEventListener('click', openModal);
});

let filmPlayer = "";
setTimeout(() => {
  filmPlayer = new Vimeo.Player(film);
}, 500);

function openModal(event) {
  if (nav.classList.contains('visible')) {
    toggleNav();
    setTimeout(() => {
      modalOverlay.classList.add('visible');
      modalOverlay.style.visibility = "visible";
    }, 400);
  } else {
    modalOverlay.classList.add('visible');
    modalOverlay.style.visibility = "visible";
  }

  if (event.target.classList.contains("view-film")) {
    filmPlayer.play();
    filmDiv.classList.add("visible");
  } else if (event.target.classList.contains("view-brochure")) {
    brochureDiv.classList.add("visible");
  }
}

modalCloseBtn.addEventListener('click', closeModal);

function closeModal() {
  modalOverlay.classList.remove('visible');

  setTimeout(() => {
    modalOverlay.style.visibility = "hidden";
  }, 400);
  filmDiv.classList.remove("visible");
  if (brochureDiv) {
    brochureDiv.classList.remove("visible");
  }
  filmPlayer.pause();
}

// Close modal when clicking off of it
window.addEventListener("click", (event) => {
  if (event.target === modalOverlay) {
    closeModal();
  }
})